import { httpResource } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { MyOrgProfileDto } from '../../shared';

@Injectable({ providedIn: 'root' })
export class OrganizationMeProfileApiService {
  readonly #base = '/api/v1/organization/me/profile';

  meProfileResource(organizationId: () => string | undefined) {
    return httpResource<MyOrgProfileDto>(() => {
      const value = organizationId();
      return value
        ? {
            url: this.#base,
            method: 'GET' as const,
            params: { organizationId: value },
            withCredentials: true,
          }
        : undefined;
    });
  }
}
